export type PendingLivenessLaunchStatus = 'opened' | 'blocked' | 'unavailable';

export type PendingLivenessLaunchResult = {
  status: PendingLivenessLaunchStatus;
  challengeId: string | null;
  url: string | null;
};

export type HttpSecurityHandlers = {
  handlePendingLivenessCheck?: () => Promise<PendingLivenessLaunchResult>;
  handleMfaRequired?: () => Promise<void>;
};

const unavailablePendingLivenessLaunchResult: PendingLivenessLaunchResult = {
  status: 'unavailable',
  challengeId: null,
  url: null,
};

let httpSecurityHandlers: HttpSecurityHandlers = {};

export const registerHttpSecurityHandlers = (handlers: HttpSecurityHandlers) => {
  httpSecurityHandlers = {
    ...httpSecurityHandlers,
    ...handlers,
  };
};

export const resetHttpSecurityHandlers = () => {
  httpSecurityHandlers = {};
};

export const handlePendingLivenessCheck = () =>
  httpSecurityHandlers.handlePendingLivenessCheck?.() ??
  Promise.resolve(unavailablePendingLivenessLaunchResult);

export const handleMfaRequired = () =>
  httpSecurityHandlers.handleMfaRequired?.() ?? Promise.resolve();
